"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAssociateAction = exports.useDispatch = exports.useState = exports.AssociateActionProvider = exports.dispatchContext = exports.stateContext = exports.initialState = void 0;

var _react = _interopRequireDefault(require("react"));

var _blocks = require("@bueno/blocks");

var _types = require("./types");

var _reducer = require("./reducer");

const initialState = {
  actions: [],
  listStatus: _types.Status.idle,
  modalStatus: _types.ModalStatus.closed,
  equipRuleIds: undefined,
  error: undefined,
  selectedAction: undefined
};
exports.initialState = initialState;

const stateContext = /*#__PURE__*/_react.default.createContext(undefined);

exports.stateContext = stateContext;

const dispatchContext = /*#__PURE__*/_react.default.createContext(undefined);

exports.dispatchContext = dispatchContext;
const AssociateActionProvider = (0, _blocks.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.AssociateActionProvider = AssociateActionProvider;
const useState = (0, _blocks.createStateHook)(stateContext);
exports.useState = useState;
const useDispatch = (0, _blocks.createDispatchHook)(dispatchContext);
exports.useDispatch = useDispatch;
const useAssociateAction = (0, _blocks.createContextHook)(stateContext, dispatchContext);
exports.useAssociateAction = useAssociateAction;